export const ru = {

    upload_max_file : 'Вы можете загрузить максимум 3 файла.',
    upload_message : 'Перетащите файл сюда или <em>нажмите, чтобы загрузить.</em>',
    upload_tip_1 : 'Вы можете загружать файлы только в форматах doc, docx и pdf.',


    notification_warning_title: 'Внимание!',
    notification_destroy: 'Выбранные вами данные будут удалены навсегда. Вы подтверждаете?',
    notification_destroy_cancel: 'Операция удаления отменена.',
    notification_sending_cancel: 'Операция отправки отменена.',
    notification_reCaptchaTitle: 'Я не робот',

    dialog_file_upload_title: 'Загрузить Файл',
    dialog_file_upload_description: 'Безупречная Печать и Высокое Качество Изготовления',
    dialog_offer_title: 'Запросить Предложение',
    dialog_offer_description: 'Безупречная Печать и Высокое Качество Изготовления',

    misc_or: 'Или',
    misc_yes: 'Да',
    misc_no: 'Нет',
    misc_search_not_found: 'К сожалению, по вашему запросу ничего не найдено.',

    inputs_choice: 'Ваш Выбор',
    inputs_your_message: 'Ваше Сообщение...',
    inputs_your_email: 'Ваш Адрес Электронной Почты',
    inputs_email: 'Электронная почта',
    inputs_first_name: 'Имя',
    inputs_last_name: 'Фамилия',
    inputs_your_phone: 'Ваш Номер Телефона',
    inputs_phone: 'Телефон',
    inputs_country: 'Страна',
    inputs_city: 'Город',
    inputs_town: 'Район',
    inputs_subject: 'Тема',
    inputs_message: 'Сообщение',
    inputs_your_full_name: 'Ваше Полное Имя',
    inputs_full_name: 'Полное Имя',
    inputs_has_access_web_site: 'Я разрешаю публикацию на веб-сайте.',

    button_send: 'Отправить',
    button_save: 'Сохранить',
}
